import { Config } from '#lib/constants/config.js';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';

// Shared by the artist Person node and artwork `creator`s so Google joins them.
export const getArtistPersonId = (slug: string) =>
	`${Config.Domain}${GlobalRoutes.ArtistsHome}/${slug}#person`;
